"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.brand = void 0;
var brand = {
  50: '#E3F6FF',
  100: '#BAE9FF',
  200: '#8CDAFF',
  300: '#6EC4FF',
  400: '#3CBFFF',
  500: '#19B4FF',
  600: '#16ADFF',
  700: '#12A4FF',
  800: '#0E9CFF',
  900: '#088CFF'
};
exports.brand = brand;
//# sourceMappingURL=brand.js.map